import React from 'react';

import { Section } from './base/Section';
import { InfoRow } from './base/InfoRow';
import { DownpaymentBreakdownSectionProps } from './types';

export const DownpaymentBreakdownSection: React.FC<
  DownpaymentBreakdownSectionProps
> = ({ paymentPlan }) => {
  return (
    <Section>
      {paymentPlan.downPaymentBreakdown?.map(
        ({ name, formattedAmount }, index) => (
          <InfoRow key={index} label={name} value={formattedAmount} />
        )
      )}
      <InfoRow
        label="Total due today"
        value={paymentPlan.downPaymentAmount}
        boldLabel
        boldValue
      />
    </Section>
  );
};
